import { Button } from '@material-ui/core';

type TProps = {
  buttonColor: string;
  children: React.ReactNode;
  handleClick: () => void;
};

const EstimateItemsUnderButton = (props: TProps) => {
  const { buttonColor, children, handleClick } = props;
  return (
    <Button
      style={{ backgroundColor: buttonColor, marginRight: 15 }}
      variant='contained'
      color='primary'
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

export default EstimateItemsUnderButton;
